import React from "react";
import 'assets/sass/common/RectangleAlert.scss';
import {images} from "assets/img/common/common";

export function RectangleAlert({type='alert', children}) {
    let icon = null;
    if (type === 'alert') {
        icon = <img src={images.information} className="information" alt="alerta informativa"/>;
    }
    else if (type == 'warning') {
        icon = <img src={images.informationWarning} className="information" alt="alerta informativa"/>;
    }
    return <div className={`rectangle-${type}`}>
        {icon}
        <p>{children}</p>
    </div>;
}
